var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-modal-block-action",
      attrs: { id: "modal-block-action" }
    },
    [
      _c("div", { staticClass: "input-search" }, [
        _c("i", { staticClass: "fa fa-search" }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchAction,
              expression: "searchAction"
            }
          ],
          attrs: { type: "text", placeholder: "Search", autocomplete: "off" },
          domProps: { value: _vm.searchAction },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchAction = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm.listActionSearch.length ||
      (_vm.searchAction && _vm.searchAction.length >= 3)
        ? _c(
            "div",
            { staticClass: "container-list-action" },
            _vm._l(_vm.listActionSearch, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "container-list-action__items",
                  on: {
                    click: function($event) {
                      _vm.selectActionBlock(item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("img", {
                      staticClass: "m__r--5",
                      attrs: {
                        src: require("@/assets/automation/" +
                          item.icon +
                          ".svg"),
                        width: "25",
                        height: "25"
                      }
                    }),
                    _vm._v(" "),
                    item.description
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "container-list-action__items-name"
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "container-list-action__items-description"
                            },
                            [_vm._v(_vm._s(item.description))]
                          )
                        ])
                      : _c(
                          "div",
                          { staticClass: "container-list-action__items-name" },
                          [_vm._v(_vm._s(item.name))]
                        )
                  ]),
                  _vm._v(" "),
                  item.childs.length
                    ? _c("i", { staticClass: "fa fa-chevron-right" })
                    : _vm._e(),
                  _vm._v(" "),
                  item.childs.length
                    ? _c(
                        "div",
                        { staticClass: "container-list-action__items-childs" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "container-list-action__group-label"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(item.name.toUpperCase()) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(item.childs, function(child, indexChilds) {
                            return _c(
                              "div",
                              {
                                key: indexChilds,
                                staticClass:
                                  "container-list-action__childs-name",
                                on: {
                                  click: function($event) {
                                    _vm.selectActionBlock(item, child)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n          " + _vm._s(child) + "\n        "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            })
          )
        : _c(
            "div",
            {
              staticClass: "container-list-action",
              attrs: { id: "list-action" }
            },
            _vm._l(_vm.listAction, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "container-list-action__group" },
                [
                  item.group_name !== "GENERAL"
                    ? _c(
                        "div",
                        { staticClass: "container-list-action__group-label" },
                        [
                          _vm._v(
                            "\n        " + _vm._s(item.group_name) + "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(item.items, function(items, indexItem) {
                    return _c(
                      "div",
                      {
                        key: indexItem,
                        staticClass: "container-list-action__items",
                        on: {
                          click: function($event) {
                            _vm.selectActionBlock(items)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("img", {
                              staticClass: "m__r--5",
                              attrs: {
                                src: require("@/assets/automation/" +
                                  items.icon +
                                  ".svg"),
                                width: "25",
                                height: "25"
                              }
                            }),
                            _vm._v(" "),
                            items.description
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "container-list-action__items-name"
                                    },
                                    [_vm._v(_vm._s(items.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "container-list-action__items-description"
                                    },
                                    [_vm._v(_vm._s(items.description))]
                                  )
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "container-list-action__items-name"
                                  },
                                  [_vm._v(_vm._s(items.name))]
                                )
                          ]
                        ),
                        _vm._v(" "),
                        items.childs.length
                          ? _c("i", { staticClass: "fa fa-chevron-right" })
                          : _vm._e(),
                        _vm._v(" "),
                        items.childs.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "container-list-action__items-childs",
                                attrs: { id: "items-childs-" + items.icon }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "container-list-action__group-label"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(items.name.toUpperCase()) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(items.childs, function(
                                  child,
                                  indexChilds
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: indexChilds,
                                      staticClass:
                                        "container-list-action__childs-name",
                                      on: {
                                        click: function($event) {
                                          _vm.selectActionBlock(items, child)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(child) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    )
                  })
                ],
                2
              )
            })
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3c1cfd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3c1cfd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/ModalListAction.vue
// module id = null
// module chunks = 